import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import MainTitle from '../MainTitle';
import Subtitle from '../Subtitle';
import Details from '../Details';
import Tag from '../Tag';
import SocialAction from '../SocialAction';
import Resume from '../Resume';
import ImgArt from '../ImgArt';
import { updateFeaturedArticle, selectArticle, getArticlesByPage, shareFeaturedArticle } from '../../../../../store/actions/ArticlesActions';
import { ARTICLES } from '../../../../../routes'
import './FeaturedArticle.scss';

function FeaturedArticle(props) {
  const {
    article,
    userId,
    updateFeaturedArticle,
    selectArticle,
    getArticlesByPage,
    shareFeaturedArticle,
  } = props;

  const [author, setAuthor] = useState('')
  
  useEffect(() => {
    if(article && article.createdBy && article.createdBy.typeUser === 'lawyer') {
      setAuthor(article.lawyerUser); 
    }else {
      setAuthor('Contacta Abogado®');
    }
  }, [])

  const link = article && article.categories && `${ARTICLES}/${article.categories[0]}/${article.id}`;

  const datePublished = moment
    .unix(article && article.createdAt && article.createdAt._seconds)
    .format('D MMMM YYYY');

  const handleLike = async () => {
    await updateFeaturedArticle(article, userId);
    const params = {
      page: 1,
      limit: 5,
    };
    await getArticlesByPage(params);
  };

  const handleShare = async () => {
    await shareFeaturedArticle(article);
    const params = {
      page: 1,
      limit: 5,
    };
    await getArticlesByPage(params);
  };

  const handleSelectArticle = () => {
    selectArticle(article);
  }
 
  return (
    <div className="featured-article">
      <div className="marker">
        <img src="/img/marker/icon.svg" alt="marcador de articulo destacado" />
      </div>
      <div className="featured-article-wrapper">
        <Link to={link}>
          <MainTitle text="Artículo destacado del mes" />
        </Link>
        <div className="article-preview">
          <Link to={link}>
            <Subtitle margin="featured" text={article && article.title} />
            <Details
              margin="featured"
              author={author}
              date={datePublished}
              time={article && article.readingTime}
            />
            <ImgArt
              image={article && article.mainImage}
              //styleImg="featured"
            />
            <div className="featured-article-tags">
              {article && article.categories &&
                article.categories.map((tag, index) => (
                  <Tag tagName={tag} key={index} />
                ))}
            </div>
            <Resume
              margin="featured"
              text={article && article.articleSummary}
              title={article && article.title}
              idPost={article && article.id}
              category={article && article.categories && article.categories[0]}
              handleSelectArticle = {handleSelectArticle}
            />
          </Link>
          <SocialAction
            likeUsers={article.like}
            likes={article && article.numberLike}
            shared={article && article.numberShare}
            link={link}
            handleLike = {handleLike}
            handleShare = {handleShare}
            shareButton
          />
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  updateFeaturedArticle: (article, userId) =>
    dispatch(updateFeaturedArticle(article, userId)),
  selectArticle: (article) => dispatch(selectArticle(article)),
  getArticlesByPage : (params) => dispatch(getArticlesByPage(params)),
  shareFeaturedArticle: (article) => dispatch(shareFeaturedArticle(article)),
});

const mapStateToProps = (state) => ({
  userId: state.authClient.uid,
});

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedArticle);
